import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { JobProvider } from './contexts/JobContext';
import { CustomerDashboard } from './pages/CustomerDashboard';
import { CustomerProfile } from './pages/CustomerProfile';
import { RequestJobPage } from './pages/RequestJobPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminJobDetails } from './pages/AdminJobDetails';
import { AdminAnalytics } from './pages/AdminAnalytics';
import { JobDetailsPage } from './pages/JobDetailsPage';
function AppRoutes() {
  const {
    user
  } = useAuth();
  return <Routes data-id="element-0">
      {/* Customer Routes */}
      <Route path="/" element={user?.role === 'admin' ? <AdminDashboard data-id="element-2" /> : <CustomerDashboard data-id="element-3" />} data-id="element-1" />
      <Route path="/profile" element={<CustomerProfile data-id="element-5" />} data-id="element-4" />
      <Route path="/request-job" element={<RequestJobPage data-id="element-7" />} data-id="element-6" />
      <Route path="/job/:id" element={<JobDetailsPage data-id="element-9" />} data-id="element-8" />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminDashboard data-id="element-11" />} data-id="element-10" />
      <Route path="/admin/job/:id" element={<AdminJobDetails data-id="element-13" />} data-id="element-12" />
      <Route path="/admin/analytics" element={<AdminAnalytics data-id="element-15" />} data-id="element-14" />

      <Route path="*" element={<Navigate to="/" data-id="element-17" />} data-id="element-16" />
    </Routes>;
}
export function App() {
  return <BrowserRouter data-id="element-18">
      <AuthProvider data-id="element-19">
        <JobProvider data-id="element-20">
          <AppRoutes data-id="element-21" />
        </JobProvider>
      </AuthProvider>
    </BrowserRouter>;
}